import React, { useState,useEffect,useRef,useCallback } from 'react';
// 아이콘 사용을 위해 react-icons/fa를 사용합니다.

import { getdailylook } from '../network/get_dailylook';

import {  MdOutlineIosShare, MdOutlineCameraAlt } from "react-icons/md";

import InfiniteScroll from 'react-infinite-scroll-component';

import { postDailylookComment } from '../network/post_dailtlookComment';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 


import dayjs from 'dayjs';
// dayjs 플러그인 가져오기
import relativeTime from 'dayjs/plugin/relativeTime';
// 한국어 로케일(locale) 가져오기
import 'dayjs/locale/ko'; 

import ImagePopup from '../components/ImagePopup';

import { getfollower } from '../network/get_follower';

import { FaHeart, FaComment, FaTrashAlt,FaCamera,FaRegHeart,FaRegComment } from 'react-icons/fa';

import { useNavigate } from 'react-router-dom';

import { getDailylookComment } from '../network/get_dailylookComment';

import {toggleDailylookLikes, MY_URL } from '../client';
import { deleteDailylookComment } from '../network/delete_delDailylookComment';

import ReportModal from '../components/ReportModal';

import { postReport } from '../network/post_report';

// 플러그인 사용 설정
dayjs.extend(relativeTime); 
// 언어를 한국어(ko)로 설정
dayjs.locale('ko'); 


// 탭 항목 정의
const TABS = [
  { key: 'rating', label: '팔로잉' },
  // { key: 'recommend', label: '주간 모디' },
  // { key: 'favorite', label: '월간 모디' },
];

     const TOAST_DURATION = 2000; // 2초


    function ShareButton({ linkToCopy }) {
      // 1. 토스트 메시지 표시 상태 관리
      const [showToast, setShowToast] = useState(false);
    
      // 2. 복사 및 알림을 처리하는 단일 함수
      const handleCopy = async () => {
        if (!linkToCopy) {
          console.error("복사할 링크가 없습니다.");
          return;
        }
    
        try {
          // ⭐️ 클립보드 API를 사용하여 링크 복사
          await navigator.clipboard.writeText(linkToCopy);
    
          // ⭐️ 복사 성공 시 토스트 메시지 표시
          setShowToast(true);
    
          // ⭐️ 일정 시간 후 토스트 메시지 숨김
          setTimeout(() => {
            setShowToast(false);
          }, TOAST_DURATION);
    
        } catch (err) {
          console.error('클립보드 복사 실패:', err);
          alert('클립보드 복사에 실패했습니다. 브라우저 권한을 확인해주세요.');
        }
      };
    
      return (
        <div style={styles.container}>
    
                  <MdOutlineIosShare size="24"  onClick={handleCopy} style={{
            marginLeft: '0px', // 아이콘 간의 간격
            cursor: 'pointer',
            marginRight:'5pt'
        }} />
    
    
          {/* ⭐️ 토스트 메시지 (조건부 렌더링) */}
          {showToast && (
            <div style={styles.toast}>
              링크를 복사했습니다. ✅
            </div>
          )}
        </div>
      );
    }

const Feed_tab = () => {

    const navigate = useNavigate();

  const BASE_URL = 'http://52.79.160.172:8001';
  const PAGE_SIZE = 10; 

  const [posts, setPosts] = useState([]);
  const [pageKey, setPageKey] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  
  const pageKeyRef = useRef(pageKey);
  useEffect(() => { pageKeyRef.current = pageKey; }, [pageKey]); 

const [commentsData, setCommentsData] = useState({});

 

     const [activeTab, setActiveTab] = useState('rating');
  const [dailylook, setDailylook] = useState(null)

const [selectedPostId, setSelectedPostId] = useState(null);

         const [isPopupOpen, setIsPopupOpen] = useState(false);




     const handleClosePopup = () => {
        setIsPopupOpen(false);
    };




const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);




const fetchPosts = useCallback(async () => {
    const currentPageKey = pageKeyRef.current;
    
    if (isLoading || !hasMore) return; 

    setIsLoading(true);
    
    try {
      // getfollower API 호출
      const response = await getfollower(currentPageKey, PAGE_SIZE);
      
      const newPosts = response.results || [];
      const totalCount = response.count; // 총 개수 필드 확인 필요

      const commentPromises = newPosts.map(post => 
        // 각 포스트의 ID를 사용하여 댓글 API 호출 (limit=1로 count만 확인)
        getDailylookComment(0, 1, post.id) 
      );
      
      // ⭐️ 2. 모든 댓글 수 호출을 병렬로 처리
      const commentResponses = await Promise.all(commentPromises);
      
      // ⭐️ 3. 포스트 ID를 키로, 댓글 수를 값으로 하는 객체 생성
      const newComments = newPosts.reduce((acc, post, index) => {
          acc[post.id] = commentResponses[index]?.count || 0;
          return acc;
      }, {});
      
      // ⭐️ 4. 기존 댓글 상태와 새로운 댓글 상태 병합
      setCommentsData(prev => ({ ...prev, ...newComments }));


      
      setPosts(prevPosts => {
          const updatedPosts = [...prevPosts, ...newPosts];
          if (updatedPosts.length >= totalCount) {
              setHasMore(false);
          }
          return updatedPosts;
      });
      
      setPageKey(prevKey => prevKey + PAGE_SIZE); 
      
    } catch (error) {
      console.error("팔로잉 피드 로드 실패:", error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
  }, [isLoading, hasMore]);

  useEffect(() => {
    // 최초 마운트 시 데이터 로드 시작
    if (pageKey === 0) {
        fetchPosts(); 
    }
  }, [fetchPosts]);



  async function processData() {

    // const pagekey = 0
    // const pagesize = 10 

    // const follower = await getfollower(pagekey,pagesize)
    // console.log(follower.results)



}




    useEffect(() => {

      
      processData()
  
    }, []);

        if (!posts) {
    return <div style={{

          display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '250px',
    }}>


      <span style={{    marginBottom: '30px',
    fontSize: '12pt'}}>불러오는 중..</span>

      <img
                              src={'loading_logo.jpg'}

                              style={{
                                width: '50px',
                                marginRight: '10px'
                                // height: '44px',
                                // borderRadius: '50%',
                                // objectFit: 'cover',
                                // marginRight: '12px',
                              }}
                            />
      

      
      </div>;
  }  


  return (
    
    // 메인 컨테이너: 상단 고정 및 양 끝 정렬
    <div style={{textAlign : 'center'}}>
          <ImagePopup 
                      isOpen={isPopupOpen} 
                      onClose={handleClosePopup} 
                  />
    <header style={styles.header}>

      <div style={{display : 'flex', justifyContent:'space-between'}}>
      
      {/* 1. 왼쪽 탭 그룹 (Flex) */}
      <div style={styles.tabGroup}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;
          
          return (
            <div 
              key={tab.key} 
              onClick={() => setIsPopupOpen(true)}
              style={styles.tabItem}
            >
              {/* 탭 텍스트 */}
              <span style={{ 
                ...styles.tabText,
                color: isActive ? styles.colors.activeText : styles.colors.inactiveText,
                fontWeight: isActive ? 'bold' : 'normal'
              }}>
                {tab.label}
              </span>
              
              {/* 활성 탭 밑줄 */}
              <div style={{
                ...styles.tabUnderline,
                // 활성 탭에만 검은색 선을 표시하고, 나머지는 투명하게 숨김
                backgroundColor: isActive ? styles.colors.activeUnderline : 'transparent'
              }} />
            </div>
          );
          
        })}
      </div>

       <div style={styles.iconGroup}>

              <MdOutlineCameraAlt 
                size={22} 
                color={styles.colors.icon} 
                onClick={() => setIsPopupOpen(true)}
                style={styles.iconStyle}
              />
            </div>
      

      </div>
    </header>

<main style={styles.mainContent}>

  <div style={styles.infoBanner}>
                내 스타일 계정을 팔로우하고 소통해보세요! 👋
            </div>
            
            {/* 팔로잉 피드에 포스트가 없을 때 */}
            {

                
            
            storedUserObject.username == 'temp' ? 
            
            
            (
                 <EmptyFeedPlaceholder />
            ) : (
                <InfiniteScroll
                    dataLength={posts.length}
                    next={fetchPosts}
                    hasMore={hasMore}
                    scrollThreshold="70%"
                    loader={<h4 style={{ textAlign: 'center', margin: '20px' }}>로딩 중...</h4>}
                    endMessage={<p style={{ textAlign: 'center', color: '#888' }}>게시물이 없습니다.</p>}
                >
                    {posts.map((post, index) => (
                       <FeedPostCard 
                key={post.id || index} 
                post={post} 
                commentCount={commentsData[post.id] || 0} // 댓글 수 전달
                onCommentClick={() => setSelectedPostId(post.id)} // 클릭 핸들러 전달
            />
                    ))}
                </InfiniteScroll>
            )}

            {selectedPostId && (
        <CommentModal 
            postId={selectedPostId} 
            isOpen={!!selectedPostId} 
            onClose={() => setSelectedPostId(null)} 
        />
    )}
            
        </main>




    </div>
  );

function EmptyFeedPlaceholder() {
    return (
        <div style={styles.emptyContainer}>

            <div style={styles.emptyTextGroup}>
                <span style={styles.emptyTitle}>로그인 후 활동해보세요</span>
            </div>
            <button style={styles.installButton} onClick={() =>{navigate('/login');}}>로그인</button>
        </div>
    );
}

};

function FeedPostCard({ post, commentCount, onCommentClick }) {
    const navigate = useNavigate();
    
    // API 응답에서 필요한 데이터 추출 (null 체크는 이미 이전 코드에서 처리)
    const timeAgo = dayjs(post.created_at).fromNow();
    const thumbnail = post.user.profile?.thumbnail || "/default-profile.png";
    const username = post.user.username;
    const height = post.user.profile.height;
    const bodyType = post.user.profile.body_type;

    const [isLike, setisLike] = useState(post.is_liked)
             const [isReportModalOpen, setIsReportModalOpen] = useState(false);

    // ⭐️ 1. 신고 처리 로직 (실제 API 호출)
    const handleReportConfirm = (reason) => {
        console.log(`신고 접수: ${post.id}에 대해 사유: ${reason}`);
        postReport(reason,post.id)
        // 여기에 신고 API 호출 로직을 구현합니다.
        // 예: api.reportPost(postId, reason);
        alert(`신고가 접수되었습니다: ${reason}`);
    };
    
    const goToUserProfile = () => {
        navigate(`/profile?id=${post.user.id}`);
    };
    
    // 좋아요 카운트가 API 응답에 없으므로 0으로 가정 (post.likes_count가 있다면 사용)
          const like = async (id) => {
           
            
            toggleDailylookLikes(id)
            setisLike(isLike => !isLike);

    
        };

    return (
        <div style={cardStyles.card}>

            <ReportModal
                isOpen={isReportModalOpen}
                onClose={() => setIsReportModalOpen(false)}
                onConfirm={handleReportConfirm}
            />
            
            {/* ⭐️ 1. 상단 정보 (닉네임, 키/체형, 아이콘) */}
            <div style={cardStyles.header}>
                <div style={cardStyles.userInfo} onClick={goToUserProfile}>
                    <img src={thumbnail} alt="Profile" style={cardStyles.profileImage} />
                    
                    <div style={cardStyles.textGroup}>
                        <span style={cardStyles.username}>{username}</span>
                        {/* ⭐️ 키와 체형을 한 줄에 띄우기 */}
                        <span style={cardStyles.details}>{height}cm · {bodyType}</span> 
                    </div>
                </div>
                {/* 점 세 개 아이콘 */}
                <span style={cardStyles.optionsIcon} onClick={() => setIsReportModalOpen(true)}>•••</span>
            </div>
            
            {/* ⭐️ 2. 메인 이미지 */}
            <img src={post.image} alt="데일리룩" style={cardStyles.mainImage} />
            
            {/* ⭐️ 3. 하단 정보 (닉네임, 시간, 좋아요/댓글) */}
            <div style={cardStyles.footer}>
                
                <div style={cardStyles.footerLeft}>
                    {/* ⭐️ 닉네임과 시간 정보를 한 줄에 */}
                    <span style={cardStyles.usernameBottom}>{username}</span>
                    <span style={cardStyles.timeAgo}>{timeAgo}</span>
                </div>
                
                <div style={cardStyles.footerRight}>
                    
                    {/* ⭐️ 좋아요/댓글 그룹 (이미지와 동일하게 배치) */}
                    <div style={cardStyles.interactionGroup}>
                        {/* 댓글 */}
                        <span style={cardStyles.commentGroup} onClick={onCommentClick}> 
                            <FaRegComment size={20} color="#333" />
                            {/* ⭐️ 댓글 수 표시 */}
                            <span style={cardStyles.countText}>{commentCount}</span> 
                        </span>
                        {
                            !isLike ? 
                        <FaRegHeart size={20}  style={{ color : isLike ?  '#ff0000ff' : '#474747ff' }} 
                        onClick={() => like(post.id)}
                          />:
                          <FaHeart size={20}  style={{ color : isLike ?  '#ff0000ff' : '#474747ff' }} 
                        onClick={() => like(post.id)}
                          />
                        }
                    </div>
                    
                    {/* 공유 아이콘 */}
                   <ShareButton linkToCopy= {MY_URL + '/dailylook?id=' + post.id+"&category=d"} />
                </div>
            </div>

            {/* ⭐️ 4. 설명 (이미지 아래 텍스트) */}
            <p style={cardStyles.introductionText}>{post.introduction}</p>
        </div>
    );
}

// ----------------------------------------------------
// 6. 빈 피드 플레이스홀더
// ----------------------------------------------------



function CommentModal({ postId, isOpen, onClose }) {
    const [comments, setComments] = useState([]);
    const [pageKey, setPageKey] = useState(0);
    const [hasMoreM, setHasMoreM] = useState(true);
    const PAGE_SIZE = 10;
   const [newComment, setNewComment] = useState('');
    // ⭐️ 새 상태: 댓글 전송 중 로딩 표시
    const [isPosting, setIsPosting] = useState(false); 
    
    // ... (기존 fetchComments 로직) ...

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    // ⭐️ 삭제할 댓글 ID와 작성자 ID를 임시 저장
    const [pendingDeleteInfo, setPendingDeleteInfo] = useState({ commentId: null, userId: null });
    
    // ⭐️ 현재 로그인된 유저 ID를 가져오는 헬퍼 함수
    const getCurrentUserId = () => {
        const savedToken = localStorage.getItem('user');
        if (!savedToken) return null;
        try {
            const storedUserObject = JSON.parse(savedToken);
            // userObject에 user.id가 저장되어 있다고 가정 (API 응답 구조 참조)
            return storedUserObject.id; 
        } catch (e) {
            console.error("로컬 스토리지 파싱 실패:", e);
            return null;
        }
    };
    
    // ⭐️ 삭제 버튼 클릭 핸들러 (권한 확인 및 팝업 띄우기)
    const handleDeleteClick = (commentId, commentUserId) => {
        const currentUserId = getCurrentUserId();
        
        // ⭐️ 현재 로그인 사용자 ID와 댓글 작성자 ID 비교
        if (currentUserId === commentUserId) {
            setPendingDeleteInfo({ commentId, userId: commentUserId });
            setShowDeleteConfirm(true); // 팝업 표시
        } else {
            alert("이 댓글을 삭제할 권한이 없습니다.");
        }
    };
    
    // ⭐️ 삭제 실행 함수
    const deleteComment = async () => {
        const { commentId } = pendingDeleteInfo;
        if (!commentId) return;

        try {
            // 🚨 deleteDailylookComment 함수 호출 (성공 시 200 OK 등)
            await deleteDailylookComment(postId, commentId); 
            
            // ⭐️ UI에서 댓글 제거
            setComments(prevComments => prevComments.filter(comment => comment.id !== commentId));
            
            // ⭐️ 댓글 수 재산정 (선택적: count 필드를 직접 업데이트할 수도 있음)
            // setCommentsCount(prevCount => prevCount - 1); 
            
            setShowDeleteConfirm(false); // 팝업 닫기
            setPendingDeleteInfo({ commentId: null, userId: null });
        } catch (error) {
            console.error("댓글 삭제 API 실패:", error);
            alert("댓글 삭제에 실패했습니다. 다시 시도해주세요.");
        }
    };

    // ⭐️ 댓글 전송 핸들러
    const handlePostComment = async () => {
        if (newComment.trim() === '' || isPosting) return;

        setIsPosting(true);
        
        try {
            // 🚨 postDailylookComment 함수는 정의되어 있다고 가정합니다.
            // API 호출: 댓글 내용과 postId를 서버에 전송
            const com = await postDailylookComment(newComment.trim(), postId); 
            console.log(com)
            setComments(prevComments => [...prevComments, com]);
            // 1. 성공 시, 입력 필드 초기화
            setNewComment('');

        //     setTimeout(() => {
        //     const scrollElement = document.getElementById('commentScroll');
        //     if (scrollElement) {
        //         // 스크롤 가능한 요소의 가장 아래로 이동
        //         scrollElement.scrollTop = scrollElement.scrollHeight; 
        //     }
        // }, 0);
            

        } catch (error) {
            console.error("댓글 전송 실패:", error);
            alert("댓글 등록에 실패했습니다.");
        } finally {
            setIsPosting(false);
        }
    };

    // 댓글 목록 로드 함수
    const fetchComments = async () => {
      console.log(hasMoreM)
        if (!hasMoreM) return;

        try {
            const response = await getDailylookComment(pageKey, PAGE_SIZE, postId);
            const newComments = response.results || [];
            
            setComments(prev => [...prev, ...newComments]);
            setPageKey(prevKey => prevKey + PAGE_SIZE);
            
            if (response.count <= comments.length + newComments.length) {
                setHasMoreM(false);
            }
        } catch (error) {
            console.error("댓글 로드 실패:", error);
            setHasMoreM(false);
        }
    };
    
    // 모달이 열릴 때 초기 데이터 로드
    useEffect(() => {
        if (isOpen && postId) {
            // 모달 열릴 때마다 상태 초기화 및 첫 페이지 로드
            setComments([]);
            setPageKey(0);
            setHasMoreM(true);
            fetchComments();
        }
    }, [isOpen, postId]); // 모달이 열리거나 포스트 ID가 변경될 때 재실행

    if (!isOpen) return null;

    return (
        <div style={modalStyles.backdrop}>
            <div style={modalStyles.content}>
                <h3 style={modalStyles.header}>댓글</h3>
                
                {/* 닫기 버튼 */}
                <button onClick={onClose} style={modalStyles.closeButton}>X</button>

                {/* InfiniteScroll을 이용한 댓글 목록 */}
                <div id="commentScroll" style={modalStyles.scrollContainer}>
                    <InfiniteScroll
                        dataLength={comments.length}
                        next={fetchComments}
                        hasMore={hasMoreM}
                        loader={<p style={{ textAlign: 'center' }}>댓글 로딩 중...</p>}
                        endMessage={<p style={{ textAlign: 'center', color: '#888' }}>더 이상 댓글이 없습니다.</p>}
                        scrollableTarget="commentScroll" // ScrollableTarget 설정
                    >
                        {comments.map((comment) => {
            // ⭐️ 현재 로그인 유저 ID와 댓글 작성자 ID 일치 여부 확인
            const currentUserId = getCurrentUserId();
            const canDelete = currentUserId === comment.user.id; // API 응답 구조: comment.user.id
            
            return (
                <div key={comment.id} style={modalStyles.commentItem}>
                    <div style={commentDisplayStyles.textWrapper}>
                        <span style={modalStyles.commentUsername}>{comment.user.username}</span>
                        <span style={modalStyles.commentContent}>{comment.content}</span>
                        <span style={modalStyles.commentTime}>{dayjs(comment.created_at).fromNow()}</span>
                    </div>
                    
                    {/* ⭐️ 삭제 버튼 (본인 댓글일 경우만 표시) */}
                    {canDelete && (
                        <FaTrashAlt
                            size={16}
                            color="#888"
                            style={commentDisplayStyles.deleteIcon}
                            onClick={() => handleDeleteClick(comment.id, comment.user.id)}
                        />
                    )}
                </div>
            );
        })}
                    </InfiniteScroll>
                </div>

                <div style={commentInputStyles.container}>
                    <input
                        type="text"
                        placeholder="댓글을 입력하세요..."
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') handlePostComment();
                        }}
                        style={commentInputStyles.input}
                        disabled={isPosting}
                    />
                    <button 
                        onClick={handlePostComment}
                        style={commentInputStyles.button}
                        disabled={isPosting || newComment.trim() === ''}
                    >
                        {isPosting ? '전송 중' : '등록'}
                    </button>
                </div>
            </div>
            {showDeleteConfirm && (
    <ConfirmationModal
        message="댓글을 삭제하시겠습니까?"
        onConfirm={deleteComment} 
        onCancel={() => setShowDeleteConfirm(false)}
    />
)}
        </div>
    );

    function ConfirmationModal({ message, onConfirm, onCancel }) {
    return (
        <div style={modalStyles.backdrop}>
            <div style={deleteConfirmStyles.content}>
                <p style={deleteConfirmStyles.message}>{message}</p>
                
                <div style={deleteConfirmStyles.buttonGroup}>
                    <button 
                        onClick={onCancel} 
                        style={deleteConfirmStyles.cancelButton}
                    >
                        아니오
                    </button>
                    <button 
                        onClick={onConfirm} 
                        style={deleteConfirmStyles.confirmButton}
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
}
}

const deleteConfirmStyles = {
    // 팝업 박스 (modalStyles.content를 오버라이드)
    content: {
        backgroundColor: 'white',
        borderRadius: '15px', 
        width: '80%',
        maxWidth: '300px',
        paddingTop: '25px',
        overflow: 'hidden',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
        position:'absolute',
        top :'40vh'
    },
    message: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '20px',
        padding: '0 20px',
    },
    buttonGroup: {
        display: 'flex',
        borderTop: '1px solid #eee',
    },
    baseButton: {
        flex: 1,
        padding: '15px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
    },
    cancelButton: {
               flex: 1,
        padding: '15px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: 'white',
        color: '#888',
        borderRight: '1px solid #eee',
    },
    confirmButton: {
                flex: 1,
        padding: '15px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: '#ff4d4f', // 빨간색
        color: 'white',
    },
};

const commentDisplayStyles = {
    commentItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 0',
        borderBottom: '1px solid #eee',
        textAlign: 'left',
    },
    textWrapper: {
        flexGrow: 1,
        marginRight: '10px',
    },
    deleteIcon: {
        flexShrink: 0,
        cursor: 'pointer',
        padding: '5px',
        opacity: 0.7,
        transition: 'opacity 0.2s',
        '&:hover': {
            opacity: 1,
        },
    }
};

const commentInputStyles = {
    container: {
        display: 'flex',
        padding: '10px 0 0 0', // 모달 내용과의 간격
        borderTop: '1px solid #eee',
        backgroundColor: 'white', // 댓글 입력창 배경색
        flexShrink: 0, // 스크롤 시 이 영역이 축소되지 않도록 고정
    },
    input: {
        flexGrow: 1,
        padding: '10px',
        border: '1px solid #ddd',
        borderRadius: '5px',
        marginRight: '10px',
        fontSize: '14px',
        outline: 'none',
    },
    button: {
        padding: '10px 15px',
        backgroundColor: '#ff4d4f',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'opacity 0.2s',
    }
};

const modalStyles = {
    backdrop: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end', // 모바일 하단에 붙도록 정렬
        zIndex: 2000,
    },
    content: {
        backgroundColor: 'white',
        width: '100%',
        maxWidth: '420px',
        height: '70%', // 화면의 70% 높이
        borderTopLeftRadius: '15px',
        borderTopRightRadius: '15px',
        padding: '20px 15px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        fontSize: '18px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: '10px',
    },
    closeButton: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        background: 'none',
        border: 'none',
        fontSize: '16px',
        cursor: 'pointer',
    },
    scrollContainer: {
        flexGrow: 1, // 남은 공간을 모두 차지
        overflowY: 'auto',
    },
    commentItem: {
        padding: '10px 0',
        borderBottom: '1px solid #eee',
        textAlign: 'left',
        display:'flex'
    },
    commentUsername: {
        fontWeight: 'bold',
        marginRight: '8px',
        fontSize: '14px',
    },
    commentContent: {
        fontSize: '14px',
        color: '#333',
        display: 'block',
        marginTop: '2px',
    },
    commentTime: {
        fontSize: '11px',
        color: '#aaa',
        marginTop: '2px',
    }
};

// ----------------------------------------------------
// 스타일 정의
// ----------------------------------------------------

const cardStyles = {
    card: {
        width: '100%',
        marginBottom: '20px',
        backgroundColor: 'white',
        borderBottom: '1px solid #f0f0f0',
        paddingBottom: '10px',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 15px 5px 15px', // 하단 패딩을 줄여서 배너와 가깝게
        // ⭐️ 배너 높이만큼 paddingTop을 줘서 content가 가려지지 않게 할 수 있지만, 
        //    피드 카드는 독립적이므로 fixed 헤더 아래에서 시작하도록 styles.mainContent에서 처리
    },
    userInfo: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    profileImage: {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginRight: '10px',
    },
    textGroup: {
        display: 'flex',
        flexDirection: 'column',
    },
    username: {
        fontWeight: 'bold',
        fontSize: '16px',
        lineHeight: 1.2,
    },
    details: {
        fontSize: '12px',
        color: '#888',
    },
    optionsIcon: {
        fontSize: '20px',
        color: '#888',
        cursor: 'pointer',
    },
    mainImage: {
        width: '100%',
        height: 'auto',
        display: 'block',
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 15px 5px 15px', // 하단 패딩 조정
    },
    footerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px', // 닉네임과 시간 사이 간격
    },
    footerRight: {
        display: 'flex',
        alignItems: 'center',
        // gap은 interactionGroup 내부에서 처리
    },
    usernameBottom: {
        fontWeight: 'bold',
        fontSize: '14px',
        marginRight: '8px',
    },
    timeAgo: {
        fontSize: '12px',
        color: '#888',
    },
    footerRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
    },
    interactionGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '15px', // 댓글/좋아요 아이콘 사이 간격
        //marginRight: '15px',
    },
    commentGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        cursor: 'pointer',
    },
    commentIcon: {
        width: '20px',
        height: '20px',
    },
    countText: {
        fontSize: '14px',
        color: '#333',
    },
    heartIcon: {
        cursor: 'pointer',
    },
    shareIcon: {
        cursor: 'pointer',
    },
    // ... (나머지 cardStyles 유지)

    // ⭐️ 소개 텍스트 추가
    introductionText: {
        fontSize: '14px',
        color: '#333',
        padding: '0 15px',
        marginTop: '5px',
        textAlign: 'left',
    }
};


const styles = {
        toast: {
        position: 'fixed', // 화면에 고정
        bottom: '20px',    // 하단 20px 위치
        left: '50%',
        transform: 'translateX(-50%)', // 가로 중앙 정렬
        backgroundColor: 'rgba(50, 50, 50, 0.9)',
        color: 'white',
        padding: '10px 20px',
        borderRadius: '8px',
        zIndex: 9999,
        opacity: 1,
        transition: 'opacity 0.3s ease-in-out',
    },


  mainContent: {
        paddingTop: '60px', 
        // infoBanner가 fixed가 아니므로, 콘텐츠는 fixed 헤더 아래에서 시작
        // padding: '0', 
    },

  infoBanner: {
        backgroundColor: '#f6f6f6',
        padding: '10px 15px',
        fontSize: '14px',
        fontWeight: '500',
        textAlign: 'center',
        //marginTop: '60px',
        marginLeft: '25px',
        marginRight: '25px',
        borderRadius: '10px'
        // zIndex: 1, // 필요에 따라 z-index 설정
    },

  emptyContainer: {
        textAlign: 'center',
        paddingTop: '100px',
    },
    emptyIcon: {
        width:'60pt', 
        borderRadius:'10pt',
        marginBottom:'10px'
    },
    emptyTextGroup: {
        marginTop:'10pt', 
        fontWeight:'bold',
        fontSize: '16px',
        lineHeight: 1.5,
    },
    emptyTitle: {
        display: 'block',
    },
    installButton: {
        marginTop: '3vh',
        background: '#e74c3c', // 빨간색
        border: 'none',
        width: '120px',
        height: '35px',
        borderRadius: '5px',
        color:'white',
        fontSize:'14px',
        fontWeight:'500',
        marginBottom:'30pt'
    },
darkOverlay: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '30%', // 이미지 높이의 약 30%를 검은색으로 덮음
        backgroundImage:'linear-gradient(0deg, black, transparent)',
        opacity: 0.9, // 약간의 투명도를 주어 자연스럽게 보이게 함
        zIndex: 1, // 별 아이콘보다 아래에 있어야 함
    },
    // 4. 별점 아이콘 그룹 스타일
    starGroup: {
        position: 'absolute',
        bottom: '10px', // 하단으로부터의 간격 조정
        left: '50%',
        transform: 'translateX(-50%)', // 중앙 정렬
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px', // 별 사이 간격
        width: '90%', // 별 그룹의 너비
        zIndex: 2, // 검은색 오버레이 위에 표시
    },
    starIcon: {
      width :'70',
      height :'70'
        // 추가 스타일이 필요하다면 여기에 정의
    },

    colors: {
        background: '#ffffff',
        border: '#d4d4d4ff',
        activeText: '#000000',
        inactiveText: '#a0a0a0', // 사진 속 회색 텍스트
        activeUnderline: '#000000',
        icon: '#000000'
    },
    header: {
        // 상단 고정 설정
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        
        // 레이아웃 설정
        display: 'flex',
        justifyContent: 'space-between', // 왼쪽 탭 그룹과 오른쪽 아이콘 그룹 분리
        alignItems: 'center',
        
        // 크기 및 외관
        height: '50px',
        backgroundColor: '#ffffff',
        borderBottom: `1px solid ${'#d4d4d4ff'}`, // 하단 구분선
        padding: '0 15px', // 좌우 패딩
        maxWidth: '420px', // 모바일 최대 너비
        margin: '0 auto', // 중앙 정렬
        zIndex: 10, // 다른 콘텐츠 위에 표시
    },
    tabGroup: {
        display: 'flex',
        alignItems: 'center',
        marginLeft:'15px'
        // 탭 사이의 공간을 줄여 사진과 유사하게 만듭니다.
    },
    tabItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0 10px', // 탭 간의 가로 간격
        cursor: 'pointer',
        height: '100%',
        justifyContent: 'flex-end', // 밑줄을 바닥에 맞춥니다.
        // 탭 텍스트에만 상단 패딩을 줄 수도 있습니다.
    },
    tabText: {
        fontSize: '16px',
        paddingBottom: '8px', // 텍스트와 밑줄 사이의 간격
        whiteSpace: 'nowrap', // 텍스트 줄바꿈 방지
    },
    tabUnderline: {
        width: '100%',
        height: '2px', // 밑줄 두께
        // 활성 상태에 따라 색상이 결정됩니다.
    },
    iconGroup: {
        display: 'flex',
        alignItems: 'center',
        marginRight:'15px'
    },
    
buttonBase: {
        backgroundColor: '#000000ff',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '6px 15px',
        cursor: 'pointer',
        fontSize: '10px',
    },

  value: {
    fontSize: '24px',
    fontWeight: 'bold',
    margin: 0,
  },

container: {
        width: '100%',
        maxWidth: '400px', // 모바일 환경에 맞게 최대 너비 설정
        
    },
    // 사진 속 둥근 박스 스타일
    itemBox: {
        display: 'flex',
        justifyContent: 'space-between', // 양 끝 정렬 (파트와 브랜드)
        alignItems: 'center',
        padding: '15px 20px',
        margin: '10px 0',
        backgroundColor: '#ffffff',
        borderRadius: '15px', // 둥근 모서리
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)', // 약간의 그림자
        cursor: 'pointer', // 클릭 가능함을 표시
    },
    // 왼쪽 텍스트 그룹 (PART + 브랜드)
    leftGroup: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000000',
    },
    // 오른쪽 브랜드/쇼핑몰 이름
    rightName: {
        fontSize: '16px',
        color: '#000000',
    },
    // '브랜드' 텍스트의 붉은색 스타일
    redText: {
        color: '#ff4d4f', // 빨간색 계열
        marginLeft: '5px',
        fontWeight: 'normal',
        fontSize: '14px',
    },


  feedContainer: {
        maxWidth: '420px',
        margin: '0 auto',
        padding: '10px 15px',
    },
    controlPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
    },
    keywordInput: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #ddd',
    },
    filterButton: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #007bff',
        backgroundColor: '#fff',
        color: '#007bff',
        cursor: 'pointer',
    },
    resultTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '15px',
    },
    postsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr', 
        gap: '1px',
    },
    postItem: {
        border: '1px solid #eee',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    postImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
  mobileContainer: {
    maxWidth: '420px', // 일반적인 모바일 최대 너비
    margin: '0 auto',  // 중앙 정렬 (웹에서 볼 경우 대비)
    // padding: '0 5vw', // 좌우 패딩을 뷰포트 너비 기준으로 설정하여 반응성 확보
  },
  
  header: {
    paddingTop: '20px',
    position:'fixed',
    top:'0',
    width:'100%',
    maxWidth:'420px',
    backgroundColor:'white',
    zIndex:'1'
  },
  
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between', // 요소들을 양 끝으로 분산
    alignItems: 'center',
  },
  
  logo: {
    width: '100px',
    // 로고는 중앙에 위치하도록 flexbox가 처리
  },
  
  iconWrapper: {
    // 아이콘 그룹을 위한 컨테이너 (각 아이콘에 개별 마진 대신 flex 사용)
    width: '30px', 
  },
  
  iconStyle: {
    // 아이콘 크기는 이미 24px로 설정됨
  },
  
  divider: {
    height: '1px', 
    backgroundColor: '#d4d4d4ff', 
    marginTop: '20px', // 수직 여백을 뷰포트 높이 기준으로 설정
  },

  infoSection: {
    display: 'flex',
    justifyContent: 'space-between', // 주간모디 그룹과 임시 박스를 양 끝으로 분산
    alignItems: 'center',
    marginBottom: '5px',
    marginTop:'100px'
  },
  
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px', // 요소 사이의 간격
  },
  
  titleText: {
    color: '#000000ff',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  
  infoIcon: {
    color: '#000000ff',
    cursor: 'pointer',
  },

  placeholderBox: {
    width: '70px',
    height: '20px',
    backgroundColor: 'rgb(0, 0, 0)',
    // flexbox가 자동으로 오른쪽 끝에 배치
  },
  
  bestTitle: {
    color: '#ff0000ff',
    fontSize: 'small',

    margin: '5px 0',
  },

  dailylooksGrid: {
    display: 'flex',
    justifyContent: 'space-between', // 두 이미지를 양 끝으로 분산
    gap: '10px', // 이미지 사이 간격
    marginTop: '10px',
  },

  dailylookImage: {
    width: '47%', // 컨테이너 너비의 49%를 차지 (간격 포함 100% 미만)
    //height: '59vw',
        borderRadius: '8px',
    objectFit: 'cover',

  },

  sliderContainer: {
      // 슬라이더 자체의 좌우 패딩을 모바일 컨테이너와 동일하게 맞추려면 padding: 0 이 필요할 수 있음
      // 여기서는 모바일 컨테이너의 패딩을 따름
      marginBottom: '20px',
      position:'relative'
      // slick-dots 커스터마이징을 위해 추가 CSS 필요
  },
  bannerLink: {
      display: 'block',
  },
  bannerImage: {
      width: '100%',
      // height: '500px',
      borderRadius: '10px', // 이미지와 같은 모서리 둥글게 처리
      display: 'block', // 인라인 요소의 기본 여백 제거
  },

  defaultTag: {
    // 배경 및 텍스트 색상
    backgroundColor: '#333333', 
    color: '#ffffff',
    
    // 모서리 둥글게
    borderRadius: '10px', 
    
    // 내부 여백 (클릭 영역 확보)
    padding: '8px 15px', 
    
    // 글꼴 설정 (폰트에 따라 다를 수 있음)
    fontSize: '14px', 
    fontWeight: 'normal',
    
    // 기타 설정
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    
    // 옆 요소와의 간격
    marginRight: '10px', 
  },
  
  // 텍스트 밑줄 스타일 (이미지와 가장 유사하게 구현하기 위해 span에 적용)
  textUnderline: {
    // 텍스트와 거의 같은 색상의 얇은 밑줄 효과
    borderBottom: '1px solid #ffffff', 
    paddingBottom: '2px', // 텍스트와 밑줄 사이의 간격
  },
  
  // 선택되었을 때의 스타일 (필요하다면)
  // activeTag: {
  //   // defaultTag 스타일을 복사하고 필요한 부분만 변경 (예: 빨간색 테두리)
  //   ...this.defaultTag,
  //   // 예시: 선택 시 배경색 변경
  //   backgroundColor: '#111111', 
  // }
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px', // 컴포넌트의 최대 너비를 제한하여 모바일에 적합하게 조정
    margin: '20px auto',
    border: '1px solid #ccc',
    borderRadius: '25px', // 둥근 모서리
    overflow: 'hidden', // 버튼과 인풋필드를 묶음
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  inputField: {
    flexGrow: 1, // 입력 필드가 남은 공간을 모두 차지하도록
    padding: '10px 15px',
    border: 'none',
    outline: 'none',
    fontSize: '16px',
    lineHeight: 1.5,
  },
  searchButton: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '10px 15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
  },

  dropdownContainer: {
    position: 'relative',
    display: 'inline-block', // 너비를 내용물에 맞춥니다.
  },
  dropdownButton: {
    padding: '10px 20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

  },
  arrow: {
    marginLeft: '10px',
    fontSize: '10px',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%', // 버튼 바로 아래에 배치
    left: 0,
    zIndex: 1000,
    minWidth: '100%',
    padding: 0,
    margin: '4px 0 0 0',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    listStyle: 'none', // 리스트 마커 제거
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  menuItem: {
    padding: '10px 20px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0', // 마우스 오버 시 배경색 변경 (인라인 스타일에서는 직접 구현 어려움)
    },
  },

    modalHeader: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '5px',
    textAlign: 'center',
  },
  modalSubtitle: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
    textAlign: 'center',
  },
  tagsGrid: {
    display: 'flex',
    flexWrap: 'wrap', // 태그를 다음 줄로 넘김
    gap: '8px',       // 태그 간의 간격
    maxHeight: '400px', // 스크롤이 필요할 경우 최대 높이 지정
    overflowY: 'auto',
    padding: '10px 0',
  },
  tagBase: {
    padding: '8px 15px',
    borderRadius: '20px', // 타원형 모양을 위한 큰 BorderRadius
    border: '1px solid transparent',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.2s, color 0.2s',
  },
  tagDefault: {
    backgroundColor: '#f0f0f0', // 비활성화된 태그 배경색 (연한 분홍색과 유사하게)
    color: '#333',
  },
  tagSelected: {
    backgroundColor: '#e64e4e', // 선택된 태그 배경색 (이미지의 빨간색)
    color: 'white',
    fontWeight: 'bold',
  },
  confirmButton: {
    width: '100%',
    padding: '15px 0',
    marginTop: '20px',
    backgroundColor: '#e64e4e', // 이미지와 같은 빨간색
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  }
  


}


export default Feed_tab;